const TIPOS_IMPORTACION = [
  {
    id: 7,
    name: 'Notificaciones PaD',
    icon: 'notification',
    onlySuperAdmin: true,
  },  
  {
    id: 6,
    name: 'Notif. Descargadas',
    icon: 'notification',
    onlySuperAdmin: true,
  }, 
  {
    id: 4,
    name: 'Empresas',
    icon: 'companies',
  },
  {
    id: 1,
    name: 'Certificados PFX',
    icon: 'certificates',
  }, 
  {
    id: 5,
    name: 'Certificados Serial',
    icon: 'certificates',
  }, 
  {
    id: 2,
    name: 'Grupos',
    icon: 'group',
  },
  {
    id: 3,
    name: 'Usuarios',
    icon: 'user',
  },
  {
    id: 8,
    name: 'Valores Metadato',
    icon: 'codecircle',
  },
  {
    id: 9,
    name: 'Emails',
    icon: 'codecircle',
  },
  {
    id: 10,
    name: 'Valores Agrupacion',
    icon: 'codecircle',
  },
  {
    id: 11,
    name: 'Agrupaciones de Valores',
    icon: 'grouping',
  },
  {
    id: 12,
    name: 'Agrupaciones de Empresas',
    icon: 'grouping',
  },
]

export {
  TIPOS_IMPORTACION
}
